<template>
    <div class="table-responsive">
        <table>
            <thead>
                <tr>
                    <th>Cant. Sellos</th>
                    <th># Caja</th>
                    <th>Serie de Caja</th>
                    <th>Serie inicial</th>
                    <th>Serie final</th>
                    <th>Comentario</th>
                    <th>Cant. Cajas</th>
                    <th>Semana</th>
                    <th>Patio de origen</th>
                    <th>Patio de destino</th>
                    <th>
                        <div>
                            <button type="button" @click="agregar" class="btn-success"><i class="fa fa-plus"></i></button>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(sello, index) in parametros" :key="index">
                    <td>
                        <div class="form-field">
                            <input-field type="number" v-model="sello.cant_sellos" input-out placeholder="Indique una cantidad..." :id="'cant_sellos' + index" name="cant_sellos[]"></input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field type="number" v-model="sello.caja_numero" input-out placeholder="Indique una cantidad..." :id="'caja_numero' + index" name="caja_numero[]"></input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field type="text" v-model="sello.serie_caja" input-out placeholder="Indique una serie de caja..." :id="'serie_caja' + index" name="serie_caja[]"></input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field type="number" v-model="sello.serie_ini" input-out placeholder="Indique una serie inicial..." :id="'serie_ini' + index" name="serie_ini[]"></input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field type="number" v-model="sello.serie_fin" input-out placeholder="Indique una serie final..." :id="'serie_fin' + index" name="serie_fin[]"></input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field type="text" v-model="sello.comentario" input-out placeholder="Indique un comentario..." :id="'comentario' + index" name="comentario[]"></input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field type="number" v-model="sello.cant_cajas" input-out placeholder="Indique una cantidad de cajas..." :id="'cant_cajas' + index" name="cant_cajas[]"></input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field type="number" v-model="sello.semana" input-out placeholder="Indique el número de semanas..." :id="'semana' + index" name="semana[]"></input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field select">
                            <div class="select-field">
                                <select v-model="sello.patio_origen" name="patio_origen[]" :id="'patio_origen' + index">
                                    <option value="">Seleccione...</option>
                                    <option v-for="patio in patios" :key="patio.code" :value="patio.code">
                                        ({{ patio.code }}) {{ patio.address }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="form-field select">
                            <div class="select-field">
                                <select v-model="sello.patio_destino" name="patio_destino[]" :id="'patio_destino' + index">
                                    <option value="">Seleccione...</option>
                                    <option v-for="patio in patios" :key="patio.code" :value="patio.code">
                                        ({{ patio.code }}) {{ patio.address }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr v-show="parametros.length === 0">
                    <td colspan="11">
                        <strong>No se ha agregado configuraciones de sellos.</strong>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        sellos: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        },
        patios: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        }
    },
    data: function () {
        return {
            parametros: this.sellos
        };
    },
    methods: {
        agregar: function () {
            this.parametros.push({
                cant_sellos: '',
                caja_numero: '',
                serie_caja: '',
                serie_ini: '',
                serie_fin: '',
                comentario: '',
                cant_cajas: '',
                semana: '',
                patio_origen: '',
                patio_destino: ''
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/clientes/TablaSellos.vue